<article
  class="duty-card"
  [class.duty-card--selected]="isSelected && isSelectable"
  [class.duty-card--family]="showFamilyDuty"
  (click)="onCardClick()"
>
  @if (isSelected && isSelectable) {
    <div class="duty-card__done-wrap">
      <app-parent-button
        variant="success"
        [fullWidth]="true"
        [loading]="isLoadingSig()"
        (clicked)="onDoneButtonClick($event)"
      >
        @if (!isLoadingSig()) {
          <span class="duty-card__done-icon" aria-hidden="true"></span>
        }
        {{ 'app.components.assignmentBoard.done' | translate }}
      </app-parent-button>
    </div>
  }

  <div
    class="duty-card__body"
    [class.duty-card__body--dimmed]="isSelected && isSelectable"
  >
    <div class="duty-card__badges">
      @if (routineProgress) {
        <span class="duty-card__badge duty-card__badge--routine">
          {{
            'app.components.assignmentBoard.card.routineProgress'
              | translate
                : {
                    name: routineProgress.routineName,
                    completed: routineProgress.completedCount,
                    total: routineProgress.totalCount,
                  }
          }}
        </span>
      }
      @if (recurrenceLabelKey()) {
        <span class="duty-card__badge duty-card__badge--recurrence">
          <img [src]="recurrenceIconSrc()" alt="" width="14" height="14" aria-hidden="true" />
          {{ recurrenceLabelKey()! | translate }}
        </span>
      }
      @if (showFamilyDuty) {
        <span class="duty-card__badge duty-card__badge--family">
          <img src="/public/svgs/family-together.svg" alt="" width="14" height="14" aria-hidden="true" />
          {{ 'app.components.assignmentBoard.card.familyDuty' | translate }}
        </span>
      }
    </div>

    <div class="duty-card__content">
      <div class="duty-card__title-row">
        <h3 class="duty-card__title">{{ title }}</h3>
        @if (isEditable) {
          <button
            type="button"
            class="duty-card__edit"
            [attr.aria-label]="'app.components.assignmentBoard.card.editAria' | translate"
            (click)="onEditClick($event)"
          >
            <img src="/public/svgs/edit-dark.svg" alt="" width="16" height="16" aria-hidden="true" />
          </button>
        }
      </div>
      <p class="duty-card__description">{{ description }}</p>
      @if (showParentNote) {
        <blockquote class="duty-card__parent-note">
          <span class="duty-card__parent-note-label">
            {{ 'app.components.assignmentBoard.card.parentNoteLabel' | translate }}
          </span>
          <p class="duty-card__parent-note-text">{{ parentNote }}</p>
        </blockquote>
      }
    </div>

    @if (showFamilyDuty) {
      <div class="duty-card__family-progress" role="list" [attr.aria-label]="'app.components.assignmentBoard.card.familyProgressAria' | translate">
        <div class="duty-card__family-step" [class.duty-card__family-step--done]="parentCompleted" role="listitem">
          <span class="duty-card__family-dot" aria-hidden="true"></span>
          <span>{{ 'app.components.assignmentBoard.card.parentPart' | translate }}</span>
          @if (parentCompleted) {
            <span class="duty-card__family-status">{{ 'app.components.assignmentBoard.card.partDone' | translate }}</span>
          }
        </div>
        <div class="duty-card__family-step" [class.duty-card__family-step--done]="status !== 'new'" role="listitem">
          <span class="duty-card__family-dot" aria-hidden="true"></span>
          <span>{{ 'app.components.assignmentBoard.card.childPart' | translate }}</span>
          @if (status === 'marked' || status === 'done') {
            <span class="duty-card__family-status">{{ 'app.components.assignmentBoard.card.partDone' | translate }}</span>
          }
        </div>
      </div>

      @if (showParentPartAction) {
        <app-parent-button
          variant="ghost"
          [fullWidth]="true"
          [loading]="isParentPartLoading()"
          (clicked)="onParentPartClick($event)"
        >
          {{ 'app.components.assignmentBoard.card.markParentPart' | translate }}
        </app-parent-button>
      }
    }

    @if (hasRewards) {
      <div class="duty-card__rewards">
        @if (rewardGold > 0) {
          <span class="duty-card__reward duty-card__reward--gold">
            {{ 'app.components.assignmentBoard.card.rewardGold' | translate: { amount: (rewardGold | number: '1.0-2')! } }}
          </span>
        }
        @if (rewardXp > 0) {
          <span class="duty-card__reward duty-card__reward--xp">
            {{ 'app.components.assignmentBoard.card.rewardXp' | translate: { amount: rewardXp } }}
          </span>
        }
      </div>
    }

    @if (showKidNote) {
      <p class="duty-card__kid-note">
        {{ 'app.components.assignmentBoard.card.kidNote' | translate: { note: completionNotes } }}
      </p>
    }

    <footer class="duty-card__footer">
      @switch (status) {
        @case ('marked') {
          @if (completionDate) {
            <div class="duty-card__meta">
              <span class="duty-card__meta-icon duty-card__meta-icon--check" aria-hidden="true"></span>
              <span class="duty-card__meta-text">
                {{ 'app.components.assignmentBoard.card.completed' | translate: { date: (completionDate * 1000 | date: 'dd.MM.yyyy')! } }}
              </span>
            </div>
          }
        }
        @case ('done') {
          @if (confirmationDate) {
            <div class="duty-card__meta">
              <span class="duty-card__meta-icon duty-card__meta-icon--check" aria-hidden="true"></span>
              <span class="duty-card__meta-text">
                {{ 'app.components.assignmentBoard.card.confirmed' | translate: { date: (confirmationDate * 1000 | date: 'dd.MM.yyyy')! } }}
              </span>
            </div>
          } @else if (completionDate) {
            <div class="duty-card__meta">
              <span class="duty-card__meta-icon duty-card__meta-icon--calendar" aria-hidden="true"></span>
              <span class="duty-card__meta-text">
                {{ 'app.components.assignmentBoard.card.completed' | translate: { date: (completionDate * 1000 | date: 'dd.MM.yyyy')! } }}
              </span>
            </div>
          }
        }
        @default {
          <div class="duty-card__meta">
            <span class="duty-card__meta-icon duty-card__meta-icon--calendar" aria-hidden="true"></span>
            <span class="duty-card__meta-text">
              {{ 'app.components.assignmentBoard.card.created' | translate: { date: (creationDate * 1000 | date: 'dd.MM.yyyy')! } }}
            </span>
            <span class="duty-card__meta-sep" aria-hidden="true">·</span>
            @if (isOverdue) {
              <span class="duty-card__meta-text duty-card__meta-text--overdue">
                {{ 'app.components.assignmentBoard.card.overdue' | translate }}
              </span>
            } @else if (read) {
              <span class="duty-card__meta-text duty-card__meta-text--seen">
                {{ 'app.components.assignmentBoard.card.seen' | translate }}
              </span>
            } @else {
              <span class="duty-card__meta-text">
                {{ 'app.components.assignmentBoard.card.notOpened' | translate }}
              </span>
            }
          </div>
        }
      }
    </footer>
  </div>
</article>
